import { useState } from "react";
import MaterialLibrary from "screens/Dashboard/Procurement/MaterialLibrary";

export function MaterialLibrarySection() {
  const [loading, setLoading] = useState(false);

  return (
    <div className="space-y-3">
      <div className="px-3">
        <h1 className="text-2xl font-semibold text-primary-text">Material Library</h1>
        <p className="text-text-gray text-sm mt-2">
          Manage organization-level material master used across procurement and warehouse.
        </p>
      </div>

      <MaterialLibrary loading={loading} setLibraryLoading={setLoading} />
    </div>
  );
}
